(function(){
  function $(sel,ctx){return (ctx||document).querySelector(sel);}
  var drawer, itemsEl, emptyEl, footerEl, subtotalEl, checkoutBtn, badgeEl;

  function money(cents){
    if(window.Shopify && Shopify.formatMoney && window.theme_money_format){
      return Shopify.formatMoney(cents, window.theme_money_format);
    }
    return '₹' + (cents/100).toFixed(0);
  }

  function render(cart){
    itemsEl.innerHTML = '';
    if(!cart.items.length){
      emptyEl.style.display = 'block';
      footerEl.style.display = 'none';
    } else {
      emptyEl.style.display = 'none';
      footerEl.style.display = 'block';
      cart.items.forEach(function(item, idx){
        var row = document.createElement('div');
        row.className = 'bw-cart-item';
        row.innerHTML =
          '<img src="' + (item.image || '') + '" alt="">' +
          '<div class="bw-cart-item__meta">' +
            '<div class="bw-cart-item__title">' + item.product_title + '</div>' +
            '<div class="bw-cart-item__qty">' +
              '<button type="button" data-qty-down>&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-up>+</button>' +
              '<span class="bw-cart-item__remove" data-remove>Remove</span>' +
            '</div>' +
            '<div class="bw-cart-item__price">' + money(item.final_line_price) + '</div>' +
          '</div>';
        row.querySelector('[data-qty-down]').addEventListener('click', function(){ changeLine(idx+1, item.quantity-1); });
        row.querySelector('[data-qty-up]').addEventListener('click', function(){ changeLine(idx+1, item.quantity+1); });
        row.querySelector('[data-remove]').addEventListener('click', function(){ changeLine(idx+1, 0); });
        itemsEl.appendChild(row);
      });
      subtotalEl.textContent = money(cart.total_price);
    }
    if(badgeEl){
      if(cart.item_count > 0){ badgeEl.style.display='flex'; badgeEl.textContent = cart.item_count; }
      else { badgeEl.style.display='none'; }
    }
  }

  function refresh(){
    return fetch('/cart.js').then(function(r){return r.json();}).then(render);
  }

  function changeLine(line, qty){
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function(r){return r.json();}).then(render);
  }

  function open(){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); refresh(); }
  function close(){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); }

  document.addEventListener('DOMContentLoaded', function(){
    drawer = $('#bw-cart-drawer');
    if(!drawer) return;
    itemsEl = $('#bw-cart-items');
    emptyEl = $('#bw-cart-empty');
    footerEl = $('#bw-cart-footer');
    subtotalEl = $('#bw-cart-subtotal');
    checkoutBtn = $('#bw-cart-checkout');
    badgeEl = $('.bw-header__count');

    document.querySelectorAll('[data-cart-open]').forEach(function(el){
      el.addEventListener('click', function(e){ e.preventDefault(); open(); });
    });
    drawer.querySelectorAll('[data-cart-close]').forEach(function(el){
      el.addEventListener('click', close);
    });
    checkoutBtn.addEventListener('click', function(){ window.location.href = '/checkout'; });

    document.querySelectorAll('.bw-ajax-cart-form').forEach(function(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var fd = new FormData(form);
        fetch('/cart/add.js', { method:'POST', body: fd })
          .then(function(r){ return r.json(); })
          .then(function(){ open(); })
          .catch(function(){ form.submit(); });
      });
    });

    refresh();
  });
})();
